import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartSankey = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M23.6794 10.4706C23.514 10.4706 23.3618 10.5434 23.2625 10.6757L18.7096 16.4662C18.0081 17.3596 16.936 17.8824 15.7978 17.8824H3.58824C2.70809 17.8824 2 17.1743 2 16.2941C2 15.414 2.70809 14.7059 3.58824 14.7059H15.7912C15.9566 14.7059 16.1088 14.6331 16.2081 14.5007L20.761 8.7103C21.4625 7.81692 22.5346 7.29413 23.6728 7.29413H36.4118C37.2919 7.29413 38 8.00222 38 8.88236C38 9.76251 37.2919 10.4706 36.4118 10.4706H23.6794ZM16.0294 24.2353L19.6029 29.3044C19.7022 29.4434 19.861 29.5294 20.0331 29.5294H36.4118C37.2919 29.5294 38 30.2375 38 31.1177C38 31.9978 37.2919 32.7059 36.4118 32.7059H20.0397C18.8353 32.7059 17.7037 32.1235 17.0088 31.1375L12.1382 24.2353H3.58824C2.70809 24.2353 2 23.5272 2 22.6471C2 21.7669 2.70809 21.0588 3.58824 21.0588H36.4118C37.2919 21.0588 38 21.7669 38 22.6471C38 23.5272 37.2919 24.2353 36.4118 24.2353H16.0294Z",
		fill: "white"
	})
});
export default SvgChartSankey;
